import { fetchDiagnosis } from "@/api/craiyon";
import { DateTime } from "luxon";
import Vue from "vue";
import { normalize, Diagnosis } from "@/store/helper";

const MODULE = "diagnosis/";
// actions
const _LOAD_DIAGNOSIS = "LOAD_DIAGNOSIS";
const _ACTION_SET_DIAGNOSIS_COUNT = "ACTION_SET_DIAGNOSIS_COUNT";
const _ACTION_SET_DIAGNOSIS_RATIO = "ACTION_SET_DIAGNOSIS_RATIO";
// mutations
const _SET_DIAGNOSIS_COUNT = "SET_DIAGNOSIS_COUNT";
const _SET_DIAGNOSIS_RATIO = "SET_DIAGNOSIS_RATIO";
const _TOGGLE_LOADING = "TOGGLE_LOADING";

// actions
export const LOAD_DIAGNOSIS = MODULE + _LOAD_DIAGNOSIS;
export const ACTION_SET_DIAGNOSIS_COUNT = MODULE + _ACTION_SET_DIAGNOSIS_COUNT;
export const ACTION_SET_DIAGNOSIS_RATIO = MODULE + _ACTION_SET_DIAGNOSIS_RATIO;
// mutations
export const SET_DIAGNOSIS_COUNT = MODULE + _SET_DIAGNOSIS_COUNT;
export const SET_DIAGNOSIS_RATIO = MODULE + _SET_DIAGNOSIS_RATIO;
export const TOGGLE_LOADING = MODULE + _TOGGLE_LOADING;

const state = {
  byName: {},
  loading: false,
  cached: false
};

const mutations = {
  [_SET_DIAGNOSIS_COUNT](state, { diagnosisName, count }) {
    state.byName[diagnosisName].count = count;
  },
  [_SET_DIAGNOSIS_RATIO](state, { diagnosisName, ratio }) {
    state.byName[diagnosisName].ratio = ratio;
  },
  [_TOGGLE_LOADING](state) {
    state.loading = !state.loading;
  },
  add: (state, item) => {
    Vue.set(state.byName, Object.keys(item)[0], Object.values(item)[0]);
    Vue.set(state.byName[Object.keys(item)[0]], "count", 0);
    Vue.set(state.byName[Object.keys(item)[0]], "ratio", 0);
  },
  setCached: (state, value) => (state.cached = value)
};

const actions = {
  async [_ACTION_SET_DIAGNOSIS_COUNT]({ commit }, { diagnosisName, count }) {
    commit(_SET_DIAGNOSIS_COUNT, {
      diagnosisName: diagnosisName,
      count: count
    });
  },
  async [_ACTION_SET_DIAGNOSIS_RATIO]({ commit }, { diagnosisName, ratio }) {
    commit(_SET_DIAGNOSIS_RATIO, {
      diagnosisName: diagnosisName,
      ratio: ratio
    });
  },
  async [_LOAD_DIAGNOSIS]({ commit, rootGetters, state }) {
    if (state.cached) {
      Object.values(state.byName).forEach(diagnosis => {
        commit(_SET_DIAGNOSIS_COUNT, {
          diagnosisName: diagnosis.name,
          count: 0
        });
        commit(_SET_DIAGNOSIS_RATIO, {
          diagnosisName: diagnosis.name,
          ratio: 0
        });
      });
      return;
    }
    commit(_TOGGLE_LOADING);
    const diagnosises = await fetchDiagnosis(rootGetters.token);
    diagnosises.results.forEach(diagnosis => {
      let r = normalize(diagnosis, Diagnosis);
      commit("add", r.entities.diagnosis);
    });
    commit("setCached", true);
    commit(_TOGGLE_LOADING);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  // getters,
  actions
};
